module.exports = __webpack_public_path__ + "img/pocket_cn.fa1b3c8.jpg";